export { default as HistorialPrecios } from "./Listado";
export { default as GraficaReportePrecios } from "./Grafica";